// Both launch practice areas share the canonical authenticated host.
export const HOME_RENDERED_APP_IDS = ["1", "2"];
export const LAUNCHABLE_APP_IDS = ["1", "2", "3", "4"];
const SUPPORTED_APP_IDS = new Set(HOME_RENDERED_APP_IDS);

export const isSupportedAppId = (appId) => SUPPORTED_APP_IDS.has(String(appId));
export const isLaunchableAppId = (appId) => LAUNCHABLE_APP_IDS.includes(String(appId));

export const isSharedProductionHost = (hostname) => {
  const normalized = String(hostname || "").trim().toLowerCase();
  return normalized === "juristai.org" || normalized === "www.juristai.org";
};
